import { render, staticRenderFns } from "./UpdatePassword.vue?vue&type=template&id=23af312b&scoped=true"
import script from "./UpdatePassword.vue?vue&type=script&lang=js"
export * from "./UpdatePassword.vue?vue&type=script&lang=js"
import style0 from "./UpdatePassword.vue?vue&type=style&index=0&id=23af312b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23af312b",
  null
  
)

export default component.exports